module.exports = __webpack_public_path__ + "static/media/icon-stuff.c4fbcd32.png";